/* custom (Second Edition), owner 2026-10-08: when a shopper switches to pickup on the cart page during open hours
   (Monday to Saturday, 11:00 to 17:00 Denver), today is preselected if Buunto offers it. Buunto otherwise keeps the
   delivery date (tomorrow) on the switch. Pre-order carts never offer today (3 business days of prep), so they are
   left alone. Runs only on a switch to pickup, so a date the shopper picks afterwards is kept. */
(() => {
  'use strict';
  if (window.sePickupToday) return;
  window.sePickupToday = true;
  const root = document.getElementById('Cart');
  if (!root) return;
  let lastMethod = root.dataset.mode === 'pickup' ? 'STORE_PICKUP' : 'LOCAL_DELIVERY';
  function pickupToday() {
    const now = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Denver', weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).map((p) => [p.type, p.value]));
    const hour = Number(now.hour);
    if (now.weekday === 'Sun' || hour < 11 || hour >= 17) return;
    const today = `${now.month} ${now.day}, ${now.year}`; // Buunto's option value, e.g. "October 8, 2026"
    const select = document.querySelector('#buunto-date-picker select');
    if (!select || select.value === today || ![...select.options].some((o) => o.value === today)) return;
    select.value = today;
    select.dispatchEvent(new Event('change', { bubbles: true })); // Buunto saves Pickup Date from its own change handler
  }
  document.addEventListener('BuuntoDatePicker:selectionChange', (e) => {
    const method = e.detail && e.detail.method;
    if (!method) return;
    if (method === 'STORE_PICKUP' && lastMethod !== 'STORE_PICKUP') setTimeout(pickupToday, 0);
    lastMethod = method;
  });
})();
